import { combineReducers } from 'redux';
import errors from './errors';
import leads from './leads';
import markets from './markets';
import activities from './activities';
import customCopy from './custom-copy';
import modal from './modal';
import smallModal from './small-modal';
import opportunityCount from './opportunity-count';
import acceptingLead from './accepting-lead';
import mqlPlusCopy from './mql-plus-copy';
import mqlPlusPricing from "./mql-plus-pricing";
import recentMqlPlusLeads from './recent-mql-plus-leads';
import activateFeature from './activate-feature';
import purchaseLeads from './purchase-leads';
import features from './features';
import user from './user';
import featureFlags from './feature-flags';
import pendingUser from './pending-user';
import formErrors from './form-errors';
import vendor from './vendor';
import nextStepProgress from './next-step-progress';
import messageBanner from './message-banner';

import awards from './product-management/awards';
import teams from './teams';
import teamUsers from './product-management/team-users';
import vendorProducts from './product-management/vendor-products';
import promotionMethods from './product-management/promotion-methods';
import products from './product-management/products';
import categories from './product-management/categories';
import dataGroups from './product-management/data-groups';
import pricing from './product-management/pricing';
import { connectRouter } from '../external/connected-react-router';


const productManagement = combineReducers({
  awards,
  promotionMethods,
  vendorProducts,
  teamUsers: teamUsers,
  products,
  categories,
  dataGroups,
  pricing,
});

const createRootReducer = (history) => combineReducers({
  user,
  vendor,
  teams,
  acceptingLead,
  errors,
  leads,
  markets,
  activities,
  customCopy,
  modal,
  smallModal,
  opportunityCount,
  mqlPlusCopy,
  mqlPlusPricing,
  recentDqLeads: recentMqlPlusLeads,
  activateFeature,
  purchaseLeads,
  features,
  featureFlags,
  formErrors,
  pendingUser,
  nextStepProgress,
  messageBanner,
  productManagement,
  router: connectRouter(history),
});

export default createRootReducer;